import { z } from "zod"

import { parseHostingPlan } from "../../ai-compute/hosting-plan"

export const powurOsComputerDataSchema = z.object({
  programId: z.number().int(),
  packageId: z.number().int(),
  gpuArchitecture: z.string().nullable(),
  gpuMemoryGb: z.number(),
  gpusPerNode: z.number().int(),
  // PowurOS sends `inputVoltageId` and may leave the voltage itself out.
  inputVoltage: z.number().nullable().default(null),
  equipmentOwnerId: z.number().int(),
  hostingTermYears: z.number().int(),
  // Requested from PowurOS (VIS-815); optional until it sends them. A value
  // of another shape reads as missing rather than failing the catalog sync.
  // The sell price only feeds the `computerSellPricePerGpuHour` contract
  // label; the Rev 2.10 payout never reads it.
  sellPricePerGpuHour: z.number().nullish().catch(null),
  nodeInputWatts: z.number().nullish().catch(null),
  // Hosting Agreement Rev 2.10 plan (`Core`, `Plus` or `Max`); PowurOS doesn't
  // send it yet, so the payout defaults it from the equipment model (#5489).
  // Read case-insensitively; any other value reads as missing rather than
  // failing the catalog sync.
  hostingPlan: z
    .unknown()
    .transform((value) =>
      value === undefined ? undefined : parseHostingPlan(value),
    ),
})

export type PowurOsComputerData = z.infer<typeof powurOsComputerDataSchema>
